import { ArrowRight, Loader2 } from "lucide-react";
import { useSiteForm } from "@/lib/site";
import { Reveal } from "./Reveal";
import { Field, Honeypot, FormError } from "./Field";

const ContactForm = () => {
  const f = useSiteForm({
    initial: { name: "", email: "", organization: "", message: "" },
    rules: ["name", "email", "message"],
    endpoint: "/site/contact",
  });
  if (f.status === "success")
    return (
      <div data-testid="contact-success" role="status" className="py-10">
        <p className="cl-heading text-3xl text-[#E6EDF4]">Thank you <span className="text-[#E7C99D]">✦</span></p>
        <p className="mt-4 text-base leading-relaxed text-[#9AAABD]">Your message has reached us. We'll reply to {f.values.email.trim()} soon.</p>
      </div>
    );
  const loading = f.status === "loading";
  return (
    <form onSubmit={f.submit} noValidate data-testid="contact-form" className="relative flex flex-col gap-5">
      <div className="grid gap-5 sm:grid-cols-2">
        <Field id="ct-name" name="name" label="Name" autoComplete="name" value={f.values.name} onChange={f.onChange} error={f.errors.name} testid="contact-name-input" />
        <Field id="ct-email" name="email" type="email" label="Email" autoComplete="email" value={f.values.email} onChange={f.onChange} error={f.errors.email} testid="contact-email-input" />
      </div>
      <Field id="ct-org" name="organization" label="Organization" optional autoComplete="organization" value={f.values.organization} onChange={f.onChange} error={f.errors.organization} testid="contact-organization-input" />
      <Field id="ct-message" as="textarea" rows={5} name="message" label="Message" value={f.values.message} onChange={f.onChange} error={f.errors.message} testid="contact-message-input" />
      <Honeypot value={f.honeypot} onChange={f.setHoneypot} testid="contact-honeypot" />
      <FormError message={f.formError} testid="contact-form-error" />
      <button type="submit" disabled={loading} data-testid="contact-submit-button" className="btn-gold mt-2 self-start">
        {loading ? <><Loader2 size={16} className="animate-spin" /> Sending…</> : <>Send message <ArrowRight size={15} strokeWidth={1.4} /></>}
      </button>
    </form>
  );
};

export const Contact = () => (
  <section id="contact" data-testid="section-contact" className="cl-section relative border-t border-[#1C2A3A]/60">
    <div className="cl-container grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
      <Reveal>
        <p className="cl-kicker">CONTACT</p>
        <h2 className="cl-heading mt-5 text-5xl text-[#E6EDF4] sm:text-6xl">Let's talk</h2>
        <p className="mt-6 max-w-sm text-base leading-relaxed text-[#9AAABD] sm:text-lg">
          For press, investors and partnerships — we'd love to hear from you.
        </p>
      </Reveal>
      <Reveal delay={120} className="cl-card p-6 sm:p-10">
        <ContactForm />
      </Reveal>
    </div>
  </section>
);
